(function ($) {
    $.fn.dropdown = function () {
        var $self = $(this);
        var $answerItem = $self.find('.js-dropdown-content');
        var $button = $self.find('.js-dropdown-button');
        var $svg = $self.find('.js-dropdown-button-icon');
        var itemActive = 'active';

        var init = function () {
            $button.on('click', function () {
                $self.toggleClass(itemActive);
                $answerItem.slideToggle();
                $svg.fadeToggle();
            });
        };
        init();
    };
    $('.js-dropdown-item').each(function() {
        $(this).data('dropdown', $(this).dropdown());
    })
})(jQuery);
